import type { PropsWithChildren } from 'react';

import PlatformClickable from '@platform-ui/clickable';
import type { DataQaInterface } from '@platform-ui/dataQa';
import dataQa from '@platform-ui/dataQa';

import cn from 'classnames';

import styles from './clickable.module.css';

type Props = React.HTMLAttributes<HTMLElement> &
  DataQaInterface & { disabled?: boolean };

export const Clickable = ({
  children,
  dataQaData,
  dataQaType,
  disabled,
  ...restProps
}: PropsWithChildren<Props>) => {
  return (
    <PlatformClickable
      {...restProps}
      {...dataQa({ dataQaData, dataQaType })}
      className={cn(styles.root, { [styles.root_disabled]: disabled })}
    >
      {children}
    </PlatformClickable>
  );
};
